<!--
 * @Description: 云途销售线索列表
 * @Author: mdb
 * @Date: 2022-07-16 10:44:19
 * @LastEditTime: 2023-06-30 09:55:53
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        rowKey="clueId"
        :row-selection="{ onChange: onSelectRowsChange }"
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosLbuSalesClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="线索状态">
              <a-radio-group
                v-model:value="queryForm.clueStatus"
                optionType="button"
                :options="clueStatusEnum"
                @change="handleQueryChange('search')"
              />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-textarea
                v-model:value="queryForm.customerName"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">QQ号</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="500"
                  allowClear
                  placeholder="请输入"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户负责人">
              <UserSelect permission v-model:value="queryForm.followerList" mode="multiple" allowClear/>
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.customerRegionList"/>
            </dc-form-item>
            <dc-form-item label="员工区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.employeeRegionList"/>
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  :options="paramCodeData.lbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="时间筛选">
              <a-input-group compact>
                <a-select v-model:value="queryForm.timeSearch.type" style="width: 33%">
                  <a-select-option :value="1">创建时间</a-select-option>
                  <a-select-option :value="2">首次领取时间</a-select-option>
                  <a-select-option :value="3">最后一次领取时间</a-select-option>
                  <a-select-option :value="4">转为潜在客户时间</a-select-option>
                </a-select>
                <CosRangePicker
                  v-model:startTime="queryForm.timeSearch.startTime"
                  v-model:endTime="queryForm.timeSearch.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="排序">
              <a-select
                v-model:value="queryForm.sortCollection"
                :options="favoriteStatus"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="未跟进天数">
              <a-select
                v-model:value="queryForm.notFollowDayNumType"
                :options="customerUnfollowDayTypeEnum"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="线索ID">
              <a-input v-model:value="queryForm.clueId" :maxlength="500" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="客户识别码">
              <a-input v-model:value="queryForm.customerSerial" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="路区代码">
              <RoadAreaSelect permission v-model:value="queryForm.roadAreaUserList" allowClear/>
            </dc-form-item>
            <dc-form-item label="客户标签">
              <CustomerLabelCascader type="search" :onlyCommon=false appId="cos_lbu" v-model:ids="queryForm.labelIdList" allowClear/>
            </dc-form-item>
            <dc-form-item label="业务类型">
              <a-select
                v-model:value="queryForm.businessTypeList"
                :options="businessTypeEnum"
                placeholder="请选择"
                mode="multiple"
                allowClear
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'lbu_clue_add_btn'" type="primary" @click="triggerAddOrEdit()">新增</a-button>
          <a-button v-permission="'lbu_clue_person_btn'" @click="handleAssignPerson()">分配负责人</a-button>
          <clue-merge-button v-permission="'lbu_clue_merge_btn'" :data="selectedData"
                             @success="handleQueryChange('fetch')" appId="cos_lbu"
          >合并
          </clue-merge-button
          >
          <ImportBtn
            v-permission="'lbu_clue_import_btn'"
            action="/lbu/api/clue/import"
            templateUrl="/lbu/api/clue/template/download"
            @success="handleQueryChange('search')"
          >导入
          </ImportBtn
          >
          <ExportButton
            v-permission="'lbu_clue_export_btn'"
            appId="cos_lbu"
            taskType="301"
            :search="handledQueryParams(queryForm)"
          >导出
          </ExportButton
          >
          <a-button v-permission="'lbu_clue_del_btn'" danger @click="handleDelete()">删除</a-button>
          <a-button v-permission="'lbu_clue_export_details_btn'" @click="handleExportDetails()">导出明细</a-button>
          <a-button @click="handleRefund()">退回</a-button>
        </template>

        <template #bodyCell="{ column, record, text, index}">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <favorite-icon type="add" v-if="record.collectionId===null"  @click="addFavorite(record,index)"/>
              <favorite-icon type="cancel" v-else  @click="cancelFavorite(record,index)" />
              <p class="new-list-flag" v-if="record.clueStatus !== 8 && record.hasFollow === false">New</p>
              <router-link
                class="ant-table-cell-ellipsis"
                :to="`/lbu/salesClue/view?clueId=${record.clueId}`"
                :title="text"
              >{{ text || '--' }}
              </router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_lbu" paramCode="lbu_source_channel" :value="text" :desc="record.channelExplain"/>
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_lbu" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'clueStatus'">
            <dc-status :enums="statusEnum" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'label'">
            <p>{{ record.label ? record.label.map((item) => item.labelName ).join('、') : '--' }}</p>
          </template>
          <template v-if="column.type === 'money'">
            <p>{{ formatThousandSeparator(text)}}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button
                v-permission="'lbu_clue_write_follow_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="handleWriteFollowUp(record.clueId)"
              >写跟进
              </a-button
              >
              <SellerButton
                v-permission="'lbu_clue_edit_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="triggerAddOrEdit(record.clueId)"
              >编辑
              </SellerButton
              >
              <SellerButton
                v-permission="'lbu_clue_potential_btn'"
                type="link"
                :workCode="record.follower"
                :disabled="record.clueStatus === 8"
                @click="handleTurnPotential(record)"
              >转为潜在客户
              </SellerButton
              >
              <a-button
                v-permission="'lbu_clue_del_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="handleDelete(record)"
              >删除
              </a-button
              >
              <a-button
                type="link"
                v-permission="'lbu_clue_map_btn'"
                :disabled="record.clueStatus === 8"
                @click="handleMap(record)"
              >签到地址
              </a-button
              >
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleQueryChange('fetch')"/>
  <!-- 客户地址修改弹窗 -->
  <CustomerMaps ref="customerMapsRef"/>

  <!-- 导出明细 -->
  <ExportDetails ref="exportDetailsRef" appId="cos_lbu" :search="queryForm" :taskTypeEnum="[
  { value: 311, label: '签到地址' },
  { value: 314, label: '在售平台' },
  { value: 317, label: '目的地国家' },
  { value: 320, label: '物流商' },
  { value: 323, label: '货物品类' },
  { value: 326, label: 'ERP系统' }
]"/>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerMaps from '@/components/CustomerMaps/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'
import ClueMergeButton from '@/components/ClueMergeButton'
import Modal from '@/hooks/modalType'
import ImportBtn from '@/components/ImportBtn'
import ClueAssign from '../components/ClueAssign.vue'
import { listByParamCodes, addToFav, cancelToFav } from '@/api/common'
import { customerListFormat } from '@/utils'
import { businessTypeEnum, customerUnfollowDayTypeEnum, customerTypeEnum, favoriteStatus } from '@/views/yuntuSales/commonEnum/dataConfig'
import { clueStatusEnum } from '../dataConfig'
import { salesClueList, salesClueDelete, salesClueDetail, salesClueRefund } from '@/api/yuntuSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuSalesClueParams, LbuSalesClueListItem } from '@/typings/api/clueManage'
import _default from 'ant-design-vue/lib/color-picker'
import props = _default.props
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'
import { Modal as AModal } from 'ant-design-vue'

const router = useRouter()
const route = useRoute()

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const statusEnum = clueStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 业务参数
const paramCodeData = reactive<{
  [key: string]: ParamCodeItem[]
}>({
  lbu_source_channel: [], // 来源渠道
  lbu_customer_business_area: [], // 业务地区
  lbu_important: [], // 潜在收入
  lbu_sales_category: [], // 销售品类
  lbu_cargo_type: [], // 货物类型
  lbu_logistics_service_provider: [], // 现有合作物流服务商
  lbu_shipping_channel: [], // 出货渠道
  lbu_daily_traffic: [], // 客户日均包裹数量
  lbu_invalid_reason: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_source_channel',
      'lbu_customer_business_area',
      'lbu_important',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_invalid_reason'
    ]
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => getByParamCodes())

const tableRef = ref()
const queryForm = reactive<LbuSalesClueParams>({
  sortCollection: 1,
  clueStatus: 3,
  contact: { type: 1 },
  timeSearch: { type: 1 }
})
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  {
    title: '客户识别码',
    dataIndex: 'customerSerial'
  },
  { title: '客户标签', dataIndex: 'label' },
  {
    title: '业务类型',
    dataIndex: 'businessType',
    dicData: businessTypeEnum
  },
  {
    title: '线索ID',
    dataIndex: 'clueId'
  },
  {
    title: '线索状态',
    dataIndex: 'clueStatus'
  },
  {
    title: '来源渠道',
    dataIndex: 'channel'
  },
  {
    title: '客户负责人',
    dataIndex: 'followerName'
  },
  {
    title: '路区代码',
    dataIndex: 'roadAreaCode'
  },
  {
    title: '前负责人',
    dataIndex: 'beforeFollowerName'
  },
  {
    title: '客户区域',
    dataIndex: 'customerRegion'
  },
  {
    title: '客户类型',
    dataIndex: 'customerType',
    dicData: customerTypeEnum
  },
  {
    title: '未跟进天数',
    dataIndex: 'notFollowDayNum'
  },
  {
    title: '客户合同地址',
    dataIndex: 'customerAddress'
  },
  {
    title: '联系人姓名',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '传真号',
    dataIndex: ['contact', 'fax']
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  // {
  //   title: '业务地区',
  //   dataIndex: ['business', 'businessArea'],
  //   dicData: paramCodeData.lbu_customer_business_area
  // },
  {
    title: '业务收入等级',
    dataIndex: ['business', 'monthIncome'],
    dicData: paramCodeData.lbu_important
  },
  {
    title: '年销售GMV(元)',
    dataIndex: ['business', 'annualSales'],
    type: 'money',
    sorter: true,
    width: 160
  },
  // {
  //   title: '销售品类',
  //   dataIndex: ['business', 'salesCategory'],
  //   dicData: paramCodeData.lbu_sales_category
  // },
  // {
  //   title: '货物类型',
  //   dataIndex: ['business', 'cargoType'],
  //   dicData: paramCodeData.lbu_cargo_type
  // },
  // {
  //   title: '现有合作物流服务商',
  //   dataIndex: ['business', 'cooperativeLogistics'],
  //   dicData: paramCodeData.lbu_logistics_service_provider
  // },
  // {
  //   title: '出货渠道',
  //   dataIndex: ['business', 'deliveryChannel'],
  //   dicData: paramCodeData.lbu_shipping_channel
  // },
  // {
  //   title: '客户日均包裹数量',
  //   dataIndex: ['business', 'dailyTraffic'],
  //   dicData: paramCodeData.lbu_daily_traffic
  // },
  {
    title: '总TPR（元/月）',
    dataIndex: ['business', 'tpr'],
    type: 'money',
    sorter: true
  },
  {
    title: '总TPR（票数/月）',
    dataIndex: ['business', 'totalPotential'],
    type: 'money',
    sorter: true
  },
  {
    title: '首次领取时间',
    dataIndex: 'firstReceiveTime',
    width: 190,
    sorter: true
  },
  {
    title: '最后一次领取时间',
    dataIndex: 'lastReceiveTime',
    width: 190,
    sorter: true
  },
  {
    title: '转潜在客户时间',
    dataIndex: 'stageChangeTime',
    width: 190
  },
  {
    title: '无效原因',
    dataIndex: 'invalidId',
    dicData: paramCodeData.lbu_invalid_reason
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190,
    sorter: true
  },
  {
    title: '更新人',
    dataIndex: 'updateByName'
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    width: 190,
    sorter: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 200,
    fixed: 'right'
  }
])
const handledQueryParams = (params: LbuSalesClueParams) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  if (queryForm.sortingFields !== undefined) {
    queryForm.sortCollection = undefined
  }
  return queryForm
}
const getList = (queryForm: LbuSalesClueParams, callBack: (res: any) => void) => {
  const params = handledQueryParams(queryForm) // 处理客户名称的批量查询参数
  salesClueList(params).then((res) => {
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: LbuSalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}

const selectedData = ref<LbuSalesClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: LbuSalesClueListItem[]) => {
  selectedData.value = selectedRows
}

// 新增编辑函数
const triggerAddOrEdit = (clueId?: string) => {
  if (clueId) {
    router.push({
      path: '/lbu/salesClue/edit',
      query: { clueId }
    })
  } else {
    router.push('/lbu/salesClue/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (clueId: string) => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: clueId,
      returnPath: route.fullPath
    }
  })
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  if (!selectedData.value.length) return message.warning('请选择需要分配的线索')
  clueAssignRef.value?.init(toRaw(selectedData.value))
}

// 转潜在客户
const handleTurnPotential = (row?: LbuSalesClueListItem) => {
  if (!row) return
  if (row.clueStatus === 5) return message.warning('无效线索不能转潜在客户')
  router.push({
    path: '/lbu/salesClue/potential',
    query: { clueId: row.clueId }
  })
}
const handleDelete = (row?: LbuSalesClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error('请选择要删除的数据')
  }
  const clueIdList: any[] = []
  const customerName = []
  if (row) {
    clueIdList.push(row.clueId)
    customerName.push(row.customerName)
  } else {
    selectedData.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      customerName.push(item.customerName)
    })
  }
  Modal.delete({
    name: customerName.join(','),
    onOk() {
      salesClueDelete({ clueIdList }).then(() => {
        message.success('删除线索成功')
        tableRef.value?.fetch()
        deleteRefresh(0)
      })
    }
  })
}

const handleRefund = () => {
  if (!selectedData.value?.length) {
    return message.error('请选择要退回的数据')
  }
  const clueIdList: any[] = []
  selectedData.value?.forEach((item) => {
    clueIdList.push(item.clueId)
  })
  AModal.confirm({
    title: '退回',
    content: '退回后线索会进入公海池，且不能再领取，是否确定退回？',
    okText: '确定',
    onOk() {
      salesClueRefund({ clueIdList }).then(() => {
        message.success('退回线索成功')
        tableRef.value?.fetch()
        deleteRefresh(0)
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}

const customerMapsRef = ref()
const handleMap = (row: LbuSalesClueListItem) => {
  customerMapsRef.value.toggle({
    addressRefId: row.clueId,
    addressRefName: row.customerName
  })
}
// 收藏
const addFavorite = (row: LbuSalesClueListItem, index:number) => {
  addToFav({
    appId: 'cos_lbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.clueId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: LbuSalesClueListItem, index:number) => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesClue' }
</script>

<style lang="scss" scoped></style>
